import { TApplicationState } from 'shared/types/redux';

export const selectCurrentDate = (state: TApplicationState): string => {
  return state.currentDate;
};
